export const BILLING_PLAN_SLUG_ENUM = {
  fixedBidMilestone: 'fixed-bid-milestone',
  timeBilling: 'time-billing',
  flatBilling: 'flat-billing'
};
